module.exports = __webpack_public_path__ + "static/media/screenshot3.054277cb.jpg";